import React from "react";
import "./Requirements.css";
import { useTranslation } from "react-i18next";

const DHLRequirements = () => {
  const { t } = useTranslation("settings");
  return (
    <div className="cuscarrier__reqrmnts_box">
      {t("carriers.custom.requirements.dhl")}
    </div>
  );
};

export default DHLRequirements;
